import {getMethod} from '~/api'

async function get(id) {
    return await getMethod(`/proxy/order/${id}/itinerary-key`)
}

export {get}
